import { getUtility } from '@livable/saas-react-components';
import { TableCell, TableRow, Typography, Chip } from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { billStatuses } from 'src/constants/utilities';
import useStyles from '../styles';
export default function AllocationProgressTableRow(_ref) {
  let _ref$utility = _ref.utility,
    utility = _ref$utility === void 0 ? {} : _ref$utility;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const allocation = utility.allocation,
    utilityType = utility.utilityType;
  const notSet = t('allocations.not_set');
  const statuses = billStatuses(t);
  const utilityData = getUtility(utilityType);
  const getChip = billStatus => {
    const status = billStatus || 'PendingCompletion';
    return /*#__PURE__*/React.createElement(Chip, {
      label: statuses[status].label,
      variant: statuses[status].variant
    });
  };
  const getDate = key => {
    if (!allocation) return notSet;
    if (!allocation[key]) return notSet;
    return moment(allocation[key]).format('L');
  };
  const getValue = key => {
    if (!allocation) return notSet;
    const value = allocation[key];
    if (value && value >= 0) {
      return value + '%';
    } else {
      return notSet;
    }
  };
  return /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", {
    className: classes.utility
  }, utilityData.icon(), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.siblingText
  }, utilityData.title))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, getDate('serviceStartDateOnly')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, getDate('serviceEndDateOnly')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, allocation && allocation.billValue ? "$".concat(allocation.billValue) : notSet), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "".concat(allocation && allocation.commonAreaDeduction || 0, "%")), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, getValue('goodwillDeduction')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "$".concat(allocation && allocation.rationBilled || 0)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "$".concat(allocation && allocation.total || 0)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, allocation ? getChip(allocation.billStatus) : null));
}
AllocationProgressTableRow.propTypes = {
  allocation: PropTypes.shape({
    billStatus: PropTypes.string,
    billValue: PropTypes.string,
    commonAreaDeduction: PropTypes.number,
    enrollment: PropTypes.string,
    goodwillDeduction: PropTypes.number,
    ratioBilled: PropTypes.string,
    submetered: PropTypes.string,
    title: PropTypes.string,
    total: PropTypes.string,
    status: PropTypes.string,
    serviceEndDateOnly: PropTypes.string,
    serviceStartDateOnly: PropTypes.string,
    isCurrent: PropTypes.bool
  }),
  utility: PropTypes.shape({
    label: PropTypes.string,
    status: PropTypes.string
  })
};